import { Bin } from './bin';
export var BinX = function BinX() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var thresholds = options.thresholds;
  return Bin(Object.assign(Object.assign({}, options), {
    thresholdsX: thresholds,
    groupChannels: ['color'],
    binChannels: ['x']
  }));
};
BinX.props = {};